import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DetailListItem from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/DetailListItem';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';


const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '400px',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(10),
  },
  rootDesktop: {
    maxWidth: '600px',
  },
  body: {
    padding: theme.spacing(0, 3),
    fontWeight: theme.typography.fontWeightBold,
  },
  actionItemContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    padding: theme.spacing(0, 3),
  },
  actionItem: {
    maxWidth: theme.dimensions.md,
    width: '100%',
    marginBottom: theme.spacing(3),
  },
  actionItemPrimaryText: {
    fontSize: theme.typography.fontSize1Pt125Rem,
  },
  actionItemSecondaryText: {
    fontWeight: theme.typography.fontWeightFacetBold,
  },
});

const Content = ({
  classes,
  resource,
}) => {
  const {
    loadPageContentLink,
  } = usePageContentContext();

  return (
    <PageContentContainer>
      <div className={classes.actionItemContainer}>
        {resource.attr('actions').resources().list().map((action) => {
          return (
            <DetailListItem
              key={action.id()}
              onClick={() => {
                loadPageContentLink(action.relationship(fr.relationships.subStep.name).link('related'));
              }}
              className={classes.actionItem}
              classes={{
                primaryText: classes.actionItemPrimaryText,
                secondaryText: classes.actionItemSecondaryText,
              }}
              resource={action}
              test={`cip-finish-action-item-${action.id()}`}
            />
          );
        })}
      </div>
    </PageContentContainer>
  );
};

Content.propTypes = {
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(Content);
